import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $BillingCountriesModuleName } from "./billingCountries.types";

const { actions } = CreateApiModule(
    $BillingCountriesModuleName,
    () => `/i18nservice/${Config.general.basestore}/i18n/countries/billing`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
